import request from 'sb-request'


const fetch = (name) =>
  request.get('rest/engine/brand', {
    query: {
      name,
    },
  })


export default {
  fetch,
}
